<template>
  <div
      id="upload-modal"
      class="modal fade upload-modal"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content modal-borderless">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t( 'uploadCertificate' ) }}</h4>
          <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click.stop.prevent="hideModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ValidationObserver ref="form">
          <form>
            <div class="modal-body">
              <p class="text-muted">{{ $t( 'uploadCertificateText' ) }}</p>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <validation-provider
                        name="certificateNumber"
                        rules="required"
                        v-slot="{ errors }"
                    >
                      <label for="certificateNumber">{{
                          $t( 'certificateNumber' )
                        }}<sup class="text-danger">*</sup></label>
                      <input
                          v-model="certificateNumber"
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': errors.length }"
                          id="certificateNumber"
                          :placeholder="$t('certificateNumber')"
                      />
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <validation-provider
                        name="validUntil"
                        rules="required"
                        v-slot="{ errors }"
                    >
                      <label for="email"
                      >{{
                          $t( 'validUntil' )
                        }}<sup class="text-danger">*</sup></label
                      >
                      <date-picker
                          v-model="validUntil"
                          :format="$t('dateFormat')"
                          value-type="YYYY-MM-DD"
                          name="validUntil"
                          :placeholder="$t('validUntil')"
                          :lang="locale"
                          class="form-control form-control_date"
                          :class="{ 'is-invalid': errors.length }"
                          id="validUntil"
                      ></date-picker>
                      <span v-cloak class="text-danger small d-none">{{
                          errors[ 0 ]
                        }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="col-lg-12 d-flex justify-content-center">
                  <validation-provider
                      name="file"
                      rules="required"
                      v-slot="{ errors }"
                      class="w-100"
                  >
                    <div
                        class="dropbox"
                        :class="{ 'is-invalid': errors.length }"
                    >
                      <input type="hidden" v-model="file"/>
                      <input
                          type="file"
                          id="assetsFieldHandle"
                          class="overflow-hidden position-absolute"
                          style="visibility: hidden"
                          @change="fileChange"
                          accept=".pdf"
                      />

                      <label
                          for="assetsFieldHandle"
                          :class="{ 'is-invalid': errors.length }"
                          class="d-block"
                      >
                        <div class="">
                          <div class="d-flex justify-content-center">
                            <div class="icon icon-upload"></div>
                          </div>
                          <div
                              class="p-1 d-flex align-items-center justify-content-center"
                              v-if="file && !alert.on"
                          >
                            {{ fileName }}
                            <button
                                type="button"
                                class="close btn btn--close text-danger mr-2"
                                aria-label="remove"
                                title="Remove file"
                                @click.stop.prevent="removeFile()"
                            >
                              <span aria-hidden="true">×</span>
                            </button>
                          </div>

                          <div class="mt-3" v-if="!alert.on && !file">
                            Click to upload File.
                          </div>
                        </div>

                        <div class="text-center" v-if="alert.on">
                          <div class="alert" :class="alert.type">
                            {{ alert.text }}
                          </div>
                        </div>
                      </label>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="modal-footer justify-content-center mt-4">
                <button
                    @click.prevent.stop="save"
                    :disabled="isLoaded"
                    class="btn btn-primary"
                >
                  {{ $t( 'save' ) }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'UploadModal',
  data() {
    return {
      locale: '',
      habilitation: {},
      certificateNumber: '',
      validUntil: null,
      file: null,
      fileName: '',
      isLoaded: false,
      alert: {
        on: false,
        type: '',
        text: ''
      }
    };
  },
  computed: {
    ...mapFields( [ 'user' ] )
  },

  mounted() {
    this.locale = this.user.local;
    //this.isLoaded = true;
    this.$bus.$on( 'upload-modal.show', ( data ) => {
      this.habilitation = data;
      $( '#upload-modal' ).modal( 'show' );
    } );
    this.$bus.$on( 'hide-upload-modal', () => {
      this.hideModal();
    } );
  },
  methods: {
    fileChange( e ) {
      let files = e.target.files;
      if ( !files.length ) return;
      this.fileName = files[ 0 ].name.length > 20 ? files[ 0 ].name.slice( 0, 20 ).concat( '...' ) : files[ 0 ].name;
      this.file = files[ 0 ];
      this.fileType = files[ 0 ].type;
    },
    hideModal() {
      $( '#upload-modal' ).modal( 'hide' );
      this.removeFile();
      this.removeData();
    },
    save() {
      this.$refs.form.validate().then( ( success ) => {
        if ( !success ) {
          this.alert.type = 'text-danger';
          this.alert.text = this.$t( 'errors.requiredFields' );
          this.alert.on = true;
          setTimeout( () => {
            this.hideAlert();
          }, 1000 );
          return;
        }
        this.isLoaded = true;
        const formData = new FormData();
        const fieldsParams = {};
        formData.append( 'file', this.file );
        formData.append( 'traineeHabilitationId', this.habilitation.id );
        fieldsParams.trainee_id = this.habilitation.traineeId;
        fieldsParams.traineeHabilitationId = this.habilitation.id;
        fieldsParams.dlv = this.validUntil;
        fieldsParams.certificate_number = this.certificateNumber;
        this.$store
            .dispatch( 'habilitations/uploadHabilitationFile', formData )
            .then( async ( resp ) => {
              this.$store
                  .dispatch( 'habilitations/updateHabilitation', fieldsParams )
                  .then( async ( resp ) => {
                    this.alert.type = "text-success";
                    this.alert.text = this.$t("savedSuccessfully");
                    this.alert.on = true;
                    setTimeout( () => {
                      this.hideModal();
                      this.$bus.$emit( 'update-habilitations-list', false);
                    }, 2000 );
                  } )
                  .catch( ( error ) => {
                    console.log( error );
                    if ( error.response.status == 422 ) {
                      this.file = null;
                      this.alert.type = 'text-danger';
                      this.alert.text = this.$t( 'errors.fileType' );
                      this.alert.on = true;
                    } else {
                      this.file = null;
                      this.alert.type = 'text-danger';
                      this.alert.text = this.$t( 'errors.serverError' );
                      this.alert.on = true;
                    }
                  } )
                  .finally( () => {
                    this.isLoaded = false;
                  } );
            } )
            .catch( ( error ) => {
              console.log( error );
              this.isLoaded = false;
              if ( error.response.status == 422 ) {
                this.file = null;
                this.alert.type = 'text-danger';
                this.alert.text = this.$t( 'errors.fileType' );
                this.alert.on = true;
              } else {
                this.file = null;
                this.alert.type = 'text-danger';
                this.alert.text = this.$t( 'errors.serverError' );
                this.alert.on = true;
              }
            } );
      } );
    },
    removeFile() {
      this.fileName = null;
      this.file = null;
    },
    removeData() {
      this.validUntil = null;
      this.certificateNumber = '';
    },
    hideAlert() {
      this.alert.on = false;
      this.alert.type = '';
      this.alert.text = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.dropbox {
  border: 1px dashed #979797;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 0;

  label {
    transition: .3s all;
    cursor: pointer;
    width: 100%;
    text-align: center;
    padding: 1rem;
    margin-bottom: 0;

    &:hover {
      background-color: #f1f4fb;
    }
  }
}

.dropbox.is-invalid {
  border: 1px dashed #ce0000;
}

.icon-upload {
  width: 100px;
  height: 100px;
}
</style>
